import React, { useEffect } from 'react'
import { getUrl } from 'aws-amplify/storage'
import './SensorCameraImage.css'

const SensorCameraImage = ({ label, keyImage, onClick }) => {
  const [src, setSrc] = React.useState('')
  useEffect(() => {
    const gUrl = async () => {
      try {
        const res = await getUrl({
          key: keyImage,
          options: {
            validateObjectExistence: true
          },
        })
        setSrc(res.url.toString())
      } catch (error) {
        setSrc('')
      }
    }
    gUrl()
  }, [keyImage])

  return (
    <div className='sensor_camera_image_container' onClick={onClick}>
      {src ? <img loading='lazy' src={src} alt='' /> : <div className='sensor_camera_image_fallback' />}
      {label && <div className='sensor_camera_image_label'>{label}</div>}
    </div>
  )
}

export default SensorCameraImage;